
import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { ToastContainer } from 'react-toastify'
import { BASE_URL } from '../../config/axios'
import { toast } from 'react-toastify';
import { handleErrorToast } from '../CustomFunctions';
import { AddwithWhiteCircle, UpdatePencil } from '../AllSvg';
import { Modal } from 'react-bootstrap';
import Select from "react-select";



const AddActivity = ({ getActivity }) => {
    const [errors, setErrors] = useState({});
    const [show, setShow] = useState(false);
    const [subActivity, setSubActivity] = useState([]);

    // Modal show
    const handleShow = () => setShow(true);

    // Modal close
    const handleClose = () => {
        setShow(false);
        setErrors({});
    };

    // Initial form data
    const [formData, setFormData] = useState({
        activity_code: "",
        activity_name: "",
        subactivity_ids: []
    });

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    // Validation logic
    const validateform = () => {
        const newErrors = {};
        const requiredFields = [
            "activity_code",
            "activity_name",
            "subactivity_ids",
        ];

        requiredFields.forEach((field) => {
            const value = formData[field];

            if (Array.isArray(value)) {
                if (value.length === 0) {
                    newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
                }
            } else {
                if (!value || value.trim() === "") {
                    newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
                }
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Submit form
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateform()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {
                const res = await axios.post(`${BASE_URL}/detail-design/activity/`, formData);

                if (res.status === 201 || res.status === 200) {
                    toast.success("Activity added successfully!");
                    setShow(false);

                    // Reset form
                    setFormData({
                        activity_code: "",
                        activity_name: "",
                        subactivity_ids: []
                    });

                    getActivity(); // Refresh list
                }
            } catch (err) {
                toast.error("Something went wrong while adding activity!");
                console.error("Error adding activity:", err);
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    // Fetch sub-activities
    const getSubActivity = async () => {
        try {
            const result = await axios.get(`${BASE_URL}/detail-design/subactivity/`);
            setSubActivity(result.data);
        } catch (err) {
            console.error("Error fetching sub-activities:", err);
        }
    };

    useEffect(() => {
        getSubActivity();
    }, []);

    // Handle select change
    const selectsubActivity = (selected) => {
        const subactivity_ids = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            subactivity_ids,
        }));
    };

    // Prepare dropdown options with UUIDs
    const options = subActivity
        ?.sort((a, b) => parseInt(a.subactivity_code) - parseInt(b.subactivity_code))
        .map((e) => ({
            value: e.id, // ✅ UUID for backend
            label: `${e.subactivity_code} - ${e.subactivity_name}`,
        }));

    return (
        <>
            <button
                title="Add Activity"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Activity
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title>Add Activity</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="register-form" onSubmit={handleFormSubmit}>
                        <div className="form-flex-wrap">
                            {/* Activity Code */}
                            <div className="flex-column">
                                <label
                                    htmlFor="activity_code"
                                    className="form-labels font-weight500 font-size-subheading"
                                >
                                    Activity Code <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="activity_code"
                                    name="activity_code"
                                    placeholder="Activity code"
                                    onChange={handleInputChange}
                                    value={formData.activity_code}
                                    className={`form-input ${errors.activity_code ? "input-error" : ""}`}
                                    style={{ width: '28vw' }}
                                />
                                {errors.activity_code && (
                                    <span className="error-message font-size-text">
                                        {errors.activity_code}
                                    </span>
                                )}
                            </div>

                            {/* Activity Name */}
                            <div className="flex-column">
                                <label
                                    htmlFor="activity_name"
                                    className="form-labels font-weight500 font-size-subheading"
                                >
                                    Activity Name <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="activity_name"
                                    name="activity_name"
                                    placeholder="Activity name"
                                    onChange={handleInputChange}
                                    value={formData.activity_name}
                                    className={`form-input ${errors.activity_name ? "input-error" : ""}`}
                                    style={{ width: '28vw' }}
                                />
                                {errors.activity_name && (
                                    <span className="error-message font-size-text">
                                        {errors.activity_name}
                                    </span>
                                )}
                            </div>

                            {/* Sub-Activity Multi-Select */}
                            <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Select Sub-Activity: <span className="required">*</span>
                                </label>
                                <Select
                                    options={options}
                                    isMulti
                                    onChange={selectsubActivity}
                                    value={formData.subactivity_ids?.map((id) => ({
                                        value: id,
                                        label: options.find((opt) => opt.value === id)?.label || id,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />
                                {errors.subactivity_ids && (
                                    <span className="error-message font-size-text">
                                        {errors.subactivity_ids}
                                    </span>
                                )}
                            </div>

                            {/* Submit Button */}
                            <div className="button-models" style={{ width: "100%" }}>
                                <button
                                    type="submit"
                                    className="model-button font-weight500 model-button-submit"
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};


const UpdateActivity = ({ i, getActivity }) => {
    const [errors, setErrors] = useState({});
    const [show, setShow] = useState(false);
    const [subActivity, setSubActivity] = useState([]);

    const [formData, setFormData] = useState({
        id: '',
        activity_code: '',
        activity_name: '',
        subactivity_ids: Array.isArray(i.subactivity_ids) ? i.subactivity_ids : []
    });

    const handleShow = () => setShow(true);

    const handleClose = () => {
        setShow(false);
        setFormData({
            id: '',
            activity_code: '',
            activity_name: '',
            subactivity_ids: Array.isArray(i.subactivity_ids) ? i.subactivity_ids : []
        });
        setErrors({});
    };

    // Pre-fill form data when editing
    useEffect(() => {
        if (i) {
            setFormData({
                id: i.id || '',
                activity_code: i.activity_code || '',
                activity_name: i.activity_name || '',
                subactivity_ids: Array.isArray(i.subactivity_ids) ? i.subactivity_ids : []  
            });
        }
    }, [i]);


    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const validateForm = () => {
        let newErrors = {};

        if (!formData.activity_code) newErrors.activity_code = "Activity code is required";
        if (!formData.activity_name) newErrors.activity_name = "Activity name is required";
        if (!formData.subactivity_ids || formData.subactivity_ids.length === 0)
            newErrors.subactivity_ids = "Please select at least one sub-activity";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            let res = await axios.put(
                `${BASE_URL}/detail-design/activityupdate/${i.id}/`,
                formData
            );

            if (res.status === 200 || res.status === 201) {
                toast.success("Activity updated successfully!");
                setShow(false);
                getActivity(); // refresh list
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };


    const getSubActivity = async () => {
        try {
            const result = await axios.get(`${BASE_URL}/detail-design/subactivity/`);
            setSubActivity(result.data);
        } catch (err) {
            console.error("Error fetching sub-activities:", err);
        }
    };

    useEffect(() => {
        getSubActivity();
    }, []);

    const selectsubActivity = (selected) => {
        const subactivity_ids = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            subactivity_ids,
        }));
    };

    const options = subActivity
        ?.sort((a, b) => parseInt(a.subactivity_code) - parseInt(b.subactivity_code))
        .map((e) => ({
            value: e.id, // ✅ UUID for backend
            label: `${e.subactivity_code} - ${e.subactivity_name}`,
        }));

    return (
        <>
            <button onClick={handleShow} className="model-edit-button">
                <UpdatePencil />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave" restoreFocus={false} >
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title>Update Activity</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="register-form" onSubmit={handleFormSubmit}>
                        <div className="form-flex-wrap">
                            {/* Sub-Activity Code */}
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Activity Code <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="activity_code"
                                    name="activity_code"
                                    placeholder="Activity code"
                                    onChange={handleInputChange}
                                    value={formData.activity_code}
                                    className={`form-input ${errors.activity_code ? 'input-error' : ''}`}
                                    style={{ width: '28vw' }}
                                />
                                {errors.activity_code && (
                                    <span className="error-message">{errors.activity_code}</span>
                                )}
                            </div>

                            {/* Sub-Activity Name */}
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Activity Name <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="activity_name"
                                    name="activity_name"
                                    placeholder="Sub-Activity name"
                                    onChange={handleInputChange}
                                    value={formData.activity_name}
                                    className={`form-input ${errors.activity_name ? 'input-error' : ''}`}
                                    style={{ width: '28vw' }}
                                />
                                {errors.activity_name && (
                                    <span className="error-message">{errors.activity_name}</span>
                                )}
                            </div>

                            <div className="flex-column form-group-select">
                                <label className="form-labels">
                                    Select Sub-Activity: <span className="required">*</span>
                                </label>
                                <Select
                                className='form-input'
                                    options={options}
                                    isMulti
                                    onChange={selectsubActivity}
                                    value={(formData.subactivity_ids || []).map((id) => ({
                                        value: id,
                                        label: options.find((opt) => opt.value === id)?.label || id,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f4f7fe',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />
                                {errors.subactivity_ids && (
                                    <span className="error-message font-size-text">
                                        {errors.subactivity_ids}
                                    </span>
                                )}
                            </div>

                            {/* Submit Button */}
                            <div className="button-models" style={{ width: '100%' }}>
                                <button type="submit" onSubmit={handleFormSubmit} className="model-button font-weight500 model-button-submit">
                                    Update
                                </button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};


const DeleteActivity = ({ i, getActivity }) => {
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true)
    }

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            let res = await axios.delete(`${BASE_URL}/detail-design/activityupdate/${i.id}/`)
            if (res.status === 200) {
                toast.success(`${i.division_name} deleted successfully`);
                await getActivity(); // refresh table
                setShow(false);
            }

        } catch (err) {
            toast.error("Failed to delete division");
        } finally {
            toast.dismiss(loadingToastId);
        }
    }


    return (
        <>
            <button
                title="Delete Insurance"
                className="model-delete-button"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Delete Activity: {i.subactivity_name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Are you sure you want to delete{" "}
                        <strong>{i.activity_name}</strong>?
                    </p>
                    <div className="button-models">
                        <button
                            className="model-button model-button-cancel"
                            onClick={() => setShow(false)}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )

}



export { AddActivity, UpdateActivity, DeleteActivity }